<template>
  <div>
    <v-row dense>
      <v-col cols="2">
        <input_decimal label="" prefix="" :amount="wizardData.weekprice_quantity" field="weekprice_quantity" @updateData="updateData"/>
      </v-col>
      <v-col cols="9" offset="1">
        <pa_radioset :value="wizardData.weekprice_operator" field="weekprice_operator" @updateData="updateData"/>
      </v-col>
    </v-row>
  </div>      
</template>

<script>

  import pa_radioset from '@/components/huis/hspt/ui/pa_radioset.vue';
  import input_decimal from '@/components/huis/hspt/ui/input_amount.vue';

  export default {
    props: {
      wizardData: Object
    },
    components: {
      pa_radioset,
      input_decimal,
    },
    methods:{
      updateData(data){
        this.$emit('updateData', data);
      },
    },
  }
</script>

<style scoped>
</style>